import { React, useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import {
    Form,
    InputGroup,
    Button,
    Row,
    Col,
    FloatingLabel
} from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { setToken } from '../../../features/auth/authSlice'
import {
    GetCandidateByID,
    updatePlacementDrive,
    fetchPlacementDrivesData,
    fetchAllSkills,
    fetchPlacementDrives,
    postNewPlacementDrive,
    fetchAllJobRoles,
    fetchAllJobRolesSkills
} from '../../../features/constants/apis'
import { useNavigate } from 'react-router'
import moment from 'moment'
import axios from 'axios'
import { FaArrowLeft } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { Title } from 'chart.js'
import userPhoto from '../../images/addImage1.png'
import addImagePng from '../../images/addImage1.png'
import { FolderPlus } from 'lucide-react'
import { useLocation } from 'react-router'

const NewPlacementDriveForm = ({ authToken, ID, role }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const GetDriveID = searchParams.get('ID')
    console.log('ID: ', GetDriveID)

    // console.log("Auth Token:", authToken);
    // console.log(ID)
    const [btnDisable, setBtnDisable] = useState(false)
    const [dotLoder, setDotLoder] = useState(false)
    const [placementTitle, setPlacementTitle] = useState('')
    const [placementCriteria, setPlacementCriteria] = useState('')
    const [numValueProfiles, setNumValueProfiles] = useState('')
    const [selectEduQualification, setSelectEduQualification] = useState(null)
    const [domain, setDomain] = useState()
    const [eligibility, setEligibility] = useState([])
    const [noOfCompany, setNoOfCompany] = useState('')
    const [selectLocation, setSelectLocation] = useState(null)
    const [domainData, setDomainData] = useState()
    const [highlights, setHighlights] = useState([{ id: Date.now(), title: '' }])
    const [process, setProcess] = useState([
        { id: Date.now(), title: '', description: '' }
    ])
    const [faq, setFAQ] = useState([{ question: '', answer: '' }])
    const [getSkill, setGetSkill] = useState()
    const [showLoader, setShowLoader] = useState(true)
    const [subTitle, setSubTitle] = useState()
    const [avragePackage, setAvragePackage] = useState()
    const [selectPSkills, setSelectPSkills] = useState([])
    const [previewImage, setPreviewImage] = useState(null)
    const [updatebtn, setUpdateBtn] = useState(false)
    const [isUpdate, setIsupdate] = useState(false)

    // Company Logo
    const [companyLogoArr, setCompanyLogoArr] = useState([])

    // Date picker
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    useEffect(() => {
        console.log('eligiblity; ', eligibility)
    }, [eligibility])

    const parseApiDate = dateString => {
        if (!dateString) return null
        const cleaned = dateString.replace(/(\d+)(st|nd|rd|th)/, '$1') // "30th April" => "30 April"
        const withYear = cleaned.includes('2025') ? cleaned : `${cleaned} 2025` // fallback if year is missing
        const parsed = new Date(withYear)

        return isNaN(parsed.getTime()) ? null : parsed
    }

    useEffect(() => {
        const getPlacementDriveByID = async () => {
            setDotLoder(true)
            if (GetDriveID && GetDriveID != 'null') {
                const data = await fetchPlacementDrivesData(GetDriveID, authToken)
                console.log('response data: ', data)
                if (data) {
                    setPlacementTitle(data.data.Title)
                    setSubTitle(data.data.SubTitle)
                    setAvragePackage(data.data.AvgPackage)
                    setNumValueProfiles(data.data.Openings)
                    setSelectEduQualification(data.data.Qualification)
                    setNoOfCompany(data.data.TotalCompany)
                    setDomain(data.data.Domain)
                    setHighlights(data.data.Highlights)
                    setProcess(data.data.Process)
                    setFAQ(data.data.Faqs)
                    setSelectPSkills(data.data.Skills || [])
                    setSelectLocation(data.data.Location)
                    setPreviewImage(data.data.Image)
                    setUploadedImage(data.data.Image)
                    setCompanyLogoArr(data.data.CompanyData || [])
                    setUpdateBtn(true)
                }
                if (data?.data?.FromDate || data?.data?.ToDate) {
                    const from = parseApiDate(data?.data?.FromDate)
                    const to = parseApiDate(data?.data?.ToDate)
                    setStartDate(from)
                    setEndDate(to)
                }
            }
            setDotLoder(false)
        }
        getPlacementDriveByID()
    }, [])
    console.log(dotLoder)

    useEffect(() => {
        const getJobroles = async () => {
            const response = await fetchAllJobRoles(authToken)
            console.log('jobroles:', response.data)
            const uniqueDomains = [
                ...new Map(response?.data.map(item => [item.Domain, item])).values()
            ]
            setDomainData(uniqueDomains)
            // console.log("uniqueDomains:", uniqueDomains?.ProfessionalSkills.map(skills => skills));
        }
        getJobroles()
    }, [authToken])
    console.log('domainData:', domainData)

    const handleInputTitle = event => {
        setPlacementTitle(event.target.value)
    }

    const handleInputCriteria = event => {
        setPlacementCriteria(event.target.value)
        console.log(placementCriteria)
    }

    const handleInputProfiles = event => {
        const newNumValue = event.target.value.replace(/\D/g, '')
        setNumValueProfiles(newNumValue)
    }

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD')
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD')

    // Validation
    const [validated, setValidated] = useState(false)

    const handleSubmit = async event => {
        setDotLoder(true)
        setBtnDisable(true)
        event.preventDefault()
        const form = event.currentTarget
        if (form.checkValidity() === false) {
            event.preventDefault()
            event.stopPropagation()
        }

        if (isUpdate) {
            const newPlacementFormData = {
                Title: placementTitle,
                SubTitle: subTitle,
                AvgPackage: avragePackage,
                Openings: numValueProfiles,
                StartDate: startDate,
                EndDate: endDate,
                Qualification: selectEduQualification,
                // 'Eligibility': eligibility,
                Image: uploadedImage,
                Domain: domain,
                NoOfCompany: noOfCompany,
                Highlights: highlights,
                Process: process,
                Faqs: faq,
                Skills: selectPSkills,
                Location: selectLocation,
                tokenUserID: ID,
                CompanyData: companyLogoArr
            }
            console.log('data to send :', newPlacementFormData)

            const UpdatePd = await updatePlacementDrive(
                GetDriveID,
                newPlacementFormData,
                authToken
            )
            console.log('placement drive updated successfully', UpdatePd)
            if (role === 'Employer') {
                navigate('/emp-placement-drives')
            }
            else if (role === 'Admin' || role === 'Counsellor') {
                navigate('/admin-placement-drives')
            }
            else {
                navigate('/emp-placement-drives')
            }
        } else {
            const newPlacementFormData = {
                Title: placementTitle,
                SubTitle: subTitle,
                AvgPackage: avragePackage,
                Openings: numValueProfiles,
                StartDate: startDate,
                EndDate: endDate,
                Qualification: selectEduQualification,
                // 'Eligibility': eligibility,
                Image: uploadedImage,
                Domain: domain,
                NoOfCompany: noOfCompany,
                Highlights: highlights,
                Process: process,
                Faqs: faq,
                Skills: selectPSkills,
                Location: selectLocation,
                tokenUserID: ID,
                CompanyData: companyLogoArr
            }
            console.log('data to send :', newPlacementFormData)
            const placementDriveData = await postNewPlacementDrive(
                newPlacementFormData,
                authToken
            )
            const updatedPlacementDrives = await fetchPlacementDrives(authToken)
            console.log(updatedPlacementDrives)

            if (updatedPlacementDrives && updatedPlacementDrives.data) {
                const employerPlacementDrives =
                    await updatedPlacementDrives.data.filter(
                        drive => drive.EmployerID === ID
                    )
                console.log('employer placement drives', employerPlacementDrives)

                employerPlacementDrives.sort((a, b) => a.ID - b.ID)
                const lastAddedPlacementDrive =
                    employerPlacementDrives[employerPlacementDrives.length - 1]
                const lastAddedPlacementDriveID = lastAddedPlacementDrive?.ID
                console.log(lastAddedPlacementDriveID)

                if (lastAddedPlacementDriveID) {
                    navigate(`/emp-placement-drives`)
                }
            }
            setValidated(true)
            setDotLoder(false)
            setBtnDisable(false)
        }
    }

    // process functionality
    const handleProcessInputChange = (id, field, value) => {
        setProcess(prevProcess =>
            prevProcess.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        )
    }
    const addProcess = () => {
        setProcess(prev => [
            ...prev,
            { id: Date.now(), title: '', description: '' }
        ])
    }

    const removeProcess = id => {
        setProcess(prevProcess => prevProcess.filter(item => item.id !== id))
    }

    // highlights functionality
    const handleHighlightsInputChange = (id, field, value) => {
        setHighlights(prevHighlights =>
            prevHighlights.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        )
    }

    const addHighlights = () => {
        setHighlights(prevHighlights => [
            ...prevHighlights,
            { id: Date.now(), title: '' } // ensures uniqueness
        ])
    }

    // Remove highlight
    const removeHighlights = index => {
        setHighlights(prevHighlights =>
            prevHighlights.filter((_, idx) => idx !== index)
        )
    }

    //FAQ input change
    const handleFAQInputChange = (id, field, value) => {
        setFAQ(prevFAQ =>
            prevFAQ.map(item => (item.id === id ? { ...item, [field]: value } : item))
        )
    }

    // Add FAQ
    const addFAQ = () => {
        setFAQ(prevFAQ => [
            ...prevFAQ,
            {
                id: Date.now(), // Or use a uuid if needed
                question: '',
                answer: ''
            }
        ])
    }

    // Remove FAQ
    const removeFAQ = id => {
        setFAQ(prevFAQ => prevFAQ.filter(item => item.id !== id))
    }

    // skills selction section start
    const [matchingJobRoleData, setMatchingJobRolesData] = useState([])
    const [checkboxGenStates, setCheckboxGenStates] = useState([])
    const [checkboxProStates, setCheckboxProStates] = useState([])
    const [showSelectGenSkillModal, setShowSelectGenSkillModal] = useState(false)
    const [selectSkill, setSelectSkill] = useState()
    const [inputValue, setInputValue] = useState('')
    const [options, setOptions] = useState([])
    const [proSugestSkills, setProSuggestSkills] = useState()
    const [genSugestSkills, setGenSuggestSkills] = useState()
    const [showPSAlert, setShowPSAlert] = useState(false)
    const [showGSAlert, setShowGSAlert] = useState(false)
    const [showProfSkillsOptions, setShowProfSkillsOptions] = useState(false)
    const [searchPQuery, setSearchPQuery] = useState('')
    const [searchGQuery, setSearchGQuery] = useState('')
    const [showGenSkillsOptions, setShowGenSkillsOptions] = useState(false)
    const [domainProfSkills, setDomainProfSkills] = useState()
    const [domainGenSkills, setDomainGenSkills] = useState()
    const [selectedSubdomains, setSelectedSubdomains] = useState([])
    const [fileName, setFileName] = useState('No file chosen')
    const [uploadingLoader, setUploadingLoader] = useState(false)
    const fileInputRef = useRef(null)
    const [imageSet, setImageSet] = useState(false)
    const [userInfo, setUserInfo] = useState([])
    const [gridValue, setGridValue] = useState()
    const [selectGSkills, setSelectGSkills] = useState([])
    const [jobRoles, setJobRoles] = useState([])
    const [candidateData, setCandidateData] = useState([])
    const [jobRolesSkills, setJobRolesSkills] = useState({
        GeneralSkills: [],
        ProfessionalSkills: [],
        ProSuggestedSkills: [],
        GenSuggestedSkills: []
    })

    useEffect(() => {
        // Prompt confirmation when reload page is triggered
        window.onbeforeunload = () => {
            return 'Data will be lost'
        }

        // Unmount the window.onbeforeunload event
        return () => {
            window.onbeforeunload = null
        }
        const tempGridValue = window.innerWidth > 600 ? 'notMobile' : 'mobile'
        setGridValue(tempGridValue)
    }, [])

    document.onkeydown = function (e) {
        if (e.key === 'r' && (e.ctrlKey || e.metaKey || e.shiftKey)) {
            e.preventDefault()
            return false
        }
    }

    const [getSkills, setGetSkills] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchAllSkills(authToken)
            setGetSkills(data)
        }
        fetchData()
    }, [authToken])

    // jobroles skills
    useEffect(() => {
        const fetchData = async () => {
            setShowLoader(true)
            try {
                const data = await fetchAllJobRolesSkills(authToken)
                setJobRolesSkills(data.data)
            } catch (error) {
                console.error('Error fetching skills.', error)
            } finally {
                setShowLoader(false)
            }
        }
        fetchData()
    }, [authToken])

    useEffect(() => {
        const domainValue = candidateData?.CareerProfile?.domain
        const matchingJobRole = jobRoles.find(jobRole => jobRole?.ID == domainValue)
        // setProSuggestSkills(matchingJobRole)
        setGenSuggestSkills(matchingJobRole)

        const matchingDomain = matchingJobRole?.Domain
        const jobRoleWithMatchingDomain = jobRoles.filter(
            jobRole => jobRole?.Domain === matchingDomain
        )
        setMatchingJobRolesData(jobRoleWithMatchingDomain)
        setCheckboxGenStates(
            new Array(jobRoleWithMatchingDomain.length).fill(false)
        )
        setCheckboxProStates(
            new Array(jobRoleWithMatchingDomain.length).fill(false)
        )
        console.log('Matching jobRoles:', { jobRoleWithMatchingDomain, jobRoles })

        const ProfSkillsbyDomain = jobRoleWithMatchingDomain
            ?.map(item => {
                return item.ProfessionalSkills?.map(skill => ({
                    value: skill,
                    label: skill,
                    subdomain: item.Subdomain
                }))
            })
            .flat()
            .filter(itm => itm)
        const AllProfessionalSkills = jobRoles
            ?.map(item => {
                return item.ProfessionalSkills?.map(skill => ({
                    value: skill,
                    label: skill,
                    subdomain: item.Subdomain
                }))
            })
            .flat()
            .filter(itm => itm)
        // console.log("Prof Skills with subdomains:", ProfSkillsbyDomain);
        // console.log("All Professional Skills:", AllProfessionalSkills);
        const uniqueProfSkillsByDomain = [
            ...new Map(
                ProfSkillsbyDomain.map(skill => [skill.value, skill]) // Use skill.value as the unique key
            ).values()
        ]
        const uniqueAllProfessionalSkills = [
            ...new Map(
                AllProfessionalSkills.map(skill => [skill.value, skill])
            ).values()
        ]
        // console.log("Unique Prof Skills by Domain:", uniqueProfSkillsByDomain);
        // console.log("ALl Unique Prof Skills:", uniqueAllProfessionalSkills);
        // setDomainProfSkills(uniqueProfSkillsByDomain);
        setDomainProfSkills(uniqueAllProfessionalSkills)

        const TopProfSkillsbyDomain = jobRoleWithMatchingDomain
            ?.map(item => {
                return item.SuggestProSkills?.map(skill => ({
                    value: skill,
                    label: skill,
                    subdomain: item.Subdomain
                }))
            })
            .flat()
            .filter(itm => itm)
        const uniqueTopProfSkillsByDomain = [
            ...new Map(
                TopProfSkillsbyDomain.map(skill => [skill.value, skill]) // Use skill.value as the unique key
            ).values()
        ]
        console.log(
            'Unique Top Prof Skills by Domain:',
            uniqueTopProfSkillsByDomain
        )
        setProSuggestSkills(uniqueTopProfSkillsByDomain)

        const GenSkillsbyDomain = [
            ...new Set(
                jobRoleWithMatchingDomain
                    .map(jobRole => jobRole?.GeneralSkills || [])
                    .flat()
            )
        ].map(skill => ({ value: skill, label: skill }))
        const AllGeneralSkills = [
            ...new Set(jobRoles.map(jobRole => jobRole?.GeneralSkills || []).flat())
        ].map(skill => ({ value: skill, label: skill }))
        const uniqueAllGeneralSkills = [
            ...new Map(AllGeneralSkills.map(skill => [skill.value, skill])).values()
        ]
        // console.log("Unique Gen Skills by Domain:", GenSkillsbyDomain);
        // console.log("All Unique Gen Skills:", uniqueAllGeneralSkills);
        setDomainGenSkills(uniqueAllGeneralSkills)
    }, [jobRoles, candidateData])

    const generalSkillOptions = jobRolesSkills?.GeneralSkills.map(skill => ({
        value: skill,
        label: skill
    }))

    const professionalSkillOptions = jobRolesSkills?.ProfessionalSkills.map(
        skill => ({
            value: skill,
            label: skill
        })
    )
    const genSuggestedSkillOptions = genSugestSkills?.SuggestGenSkills?.map(
        skill => ({
            value: skill,
            label: skill
        })
    )

    const handleSelectedGeneralSkills = selectedOptions => {
        const selectGSkills = selectedOptions.map(option => option.value)
        setSelectGSkills(selectGSkills)
    }
    const handleSelectedProfessionalSkills = selectedOptions => {
        const selectPSkills = selectedOptions.map(option => option.value)
        setSelectPSkills(selectPSkills)
        console.log('Selected Skills:', selectPSkills)
    }

    const [hasError, setHasError] = useState({
        selectGSkills: false,
        selectPSkills: false
    })

    const showErrorMsg = e => {
        const showError = { ...hasError }
        console.log(showError)
        if (e === 'Select General Skills') {
            console.log(e)
        }
        if (e === 'Select Professional Skills') {
            console.log(e)
        }
    }

    useEffect(() => {
        const fetchCandidateByID = async () => {
            const data = await GetCandidateByID(ID, authToken)
            setCandidateData(data.data)
            console.log('CANDIDATE DATA', data.data)
            if (data?.data?.SkillProfile?.ProfessionalSkills?.length > 0) {
                // setSelectPSkills(data.data.SkillProfile.ProfessionalSkills)
            }
        }
        fetchCandidateByID()
    }, [ID, authToken])

    useEffect(() => {
        const fetchJobRoles = async () => {
            const data = await fetchAllJobRoles(authToken)
            setJobRoles(data.data)
        }
        fetchJobRoles()
    }, [authToken])

    // General Skills

    const handleGenCheckboxChange = idx => {
        // Update the checked state for the checkbox at the given index
        setCheckboxGenStates(prevStates => {
            const newState = [...prevStates]
            newState[idx] = !newState[idx]
            return newState
        })
        if (!checkboxGenStates[idx]) {
            const seletedJobRoleGenSkills = matchingJobRoleData[idx]?.GeneralSkills
            // Add new skills to selectGSkills
            const updatedSkills = Array.from(
                new Set([...selectGSkills, ...seletedJobRoleGenSkills])
            )
            setSelectGSkills(updatedSkills)
        } else {
            const deselectedJobRoleGenSkills = matchingJobRoleData[idx]?.GeneralSkills
            // Remove deselected skills from selectGSkills
            const updatedSkills = selectGSkills.filter(
                skill => !deselectedJobRoleGenSkills.includes(skill)
            )
            setSelectGSkills(updatedSkills)
        }
    }

    const handleGenSkillSelect = skill => {
        const updatedSkills = Array.from(new Set([...selectGSkills, skill]))
        setSelectGSkills(updatedSkills)
    }

    // professional Skills

    const handleProCheckboxChange = idx => {
        // Set the checked state of the checkbox
        setCheckboxProStates(prevStates => {
            const newStates = [...prevStates]
            newStates[idx] = !newStates[idx]
            return newStates
        })
        if (!checkboxProStates[idx]) {
            const selectedJobRoleProSkills =
                matchingJobRoleData[idx]?.ProfessionalSkills
            const updatedSkills = Array.from(
                new Set([...selectPSkills, ...selectedJobRoleProSkills])
            )
            setSelectPSkills(updatedSkills)
        } else {
            const deselectedJobRoleProSkills =
                matchingJobRoleData[idx]?.ProfessionalSkills
            const updatedSkills = selectPSkills.filter(
                skill => !deselectedJobRoleProSkills.includes(skill)
            )
            setSelectPSkills(updatedSkills)
        }
    }

    const verifyGenCheckboxStates = () => {
        const updatedCheckboxGenStates = checkboxGenStates.map((checked, idx) => {
            const jobRoleSkills = matchingJobRoleData[idx]?.GeneralSkills || []
            const allSkillsPresent = jobRoleSkills.every(skill =>
                selectGSkills.includes(skill)
            )
            return allSkillsPresent
        })
        setCheckboxGenStates(updatedCheckboxGenStates)
    }

    const verifyProCheckboxStates = () => {
        const updatedCheckboxProStates = checkboxProStates.map((checked, idx) => {
            const jobRoleSkills = matchingJobRoleData[idx]?.ProfessionalSkills || []
            const allSkillsPresent = jobRoleSkills.every(skill =>
                selectPSkills.includes(skill)
            )
            return allSkillsPresent
        })
        setCheckboxProStates(updatedCheckboxProStates)
    }

    useEffect(() => {
        verifyGenCheckboxStates()
    }, [selectGSkills, matchingJobRoleData])

    useEffect(() => {
        verifyProCheckboxStates()
    }, [selectPSkills, matchingJobRoleData])

    const handleRemoveGenSkill = skill => {
        const updatedSkills = selectGSkills.filter(allSkills => allSkills !== skill)
        setSelectGSkills(updatedSkills)
    }

    const handleRemoveProSkill = skill => {
        const updatedSkills = selectPSkills.filter(allSkills => allSkills !== skill)
        console.log(updatedSkills)
        setSelectPSkills(updatedSkills)
        const { subdomain } =
            domainProfSkills?.find(ps => ps.value === skill) ||
            proSugestSkills?.find(ps => ps.value === skill) ||
            {}
        setSelectedSubdomains(previousSubdomains => {
            const remainingSkillsInSubdomain = domainProfSkills?.filter(
                ps => ps.subdomain === subdomain && updatedSkills.includes(ps.value)
            )
            if (!remainingSkillsInSubdomain.length) {
                return previousSubdomains.filter(sd => sd !== subdomain)
            }
            return previousSubdomains
        })
        console.log('Remaining subdomains:', selectedSubdomains)
    }

    // filtered out duplicate domains
    const uniqueDomain = Array.from(
        new Set(
            jobRoles.filter(role => role.AppVisibility).map(role => role.Domain)
        )
    ).map(domain =>
        jobRoles.find(role => role.Domain === domain && role.AppVisibility)
    )
    const UniqueDomain = [
        { ID: 1, skill: 'java' },
        { ID: 2, skill: 'paython' },
        { ID: 3, skill: 'react' },
        { ID: 4, skill: 'node' },
        { ID: 5, skill: 'postgressql' },
        { ID: 6, skill: 'javaScript' }
    ]
    // Debounce utility function
    const debounce = (func, delay) => {
        let timeout
        return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => func(...args), delay)
        }
    }
    // Debounced function to update options based on inputValue
    const updateOptions = debounce(value => {
        const filteredOptions = UniqueDomain.filter(role =>
            role.skill.toLowerCase().includes(value.toLowerCase())
        ).map(role => ({ value: role.ID, label: role.skill }))
        setOptions(filteredOptions)
    }, 1000)

    const searchProfSkillsRef = useRef()
    const handleProfSkillsFocus = () => setShowProfSkillsOptions(true)
    const handleProfSkillsBlur = e => {
        setTimeout(() => {
            if (!searchProfSkillsRef?.current.contains(e.relatedTarget)) {
                setShowProfSkillsOptions(false)
            }
        }, 1000)
    }
    const handleProfSearchChange = e => {
        setSearchPQuery(e.target.value)
    }
    const filteredProfSkillOptions = domainProfSkills
        ?.filter(
            skill =>
                skill.label &&
                skill.value &&
                skill.label.trim() !== '' &&
                skill.value.trim() !== '' &&
                (searchPQuery ? skill.value.toLowerCase().includes(searchPQuery) : true)
        )
        .sort((a, b) => {
            const indexA = selectedSubdomains.indexOf(a.subdomain)
            const indexB = selectedSubdomains.indexOf(b.subdomain)

            // If both skills' subdomains are in selectSubdomains, sort by their order in selectSubdomains
            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB
            }
            // If only one skill's subdomain is in selectSubdomains, prioritize it
            if (indexA !== -1) return -1
            if (indexB !== -1) return 1
            // If neither skill's subdomain is in selectSubdomains, maintain original order
            return 0
        })
    // console.log('Filtered Prof Skills:', filteredProfSkillOptions)
    const filteredTopProfSkillOptions = proSugestSkills?.filter(
        skill =>
            skill.label &&
            skill.value &&
            skill.label.trim() !== '' &&
            skill.value.trim() !== '' &&
            (searchPQuery ? skill.value.toLowerCase().includes(searchPQuery) : true)
    )

    const excludedProfSkills = selectPSkills || []
    const visibleAllProfSkillsOptions = filteredProfSkillOptions?.filter(
        skill => !excludedProfSkills.includes(skill.value)
    )
    const visibleSuggestedProfSkillsOptions = proSugestSkills?.filter(
        skill => !excludedProfSkills.includes(skill.value)
    )
    console.log(visibleSuggestedProfSkillsOptions)
    const searchGenSkillsRef = useRef()
    const handleGenSkillsFocus = () => setShowGenSkillsOptions(true)
    const handleGenSkillsBlur = e => {
        setTimeout(() => {
            if (!searchGenSkillsRef.current.contains(e.relatedTarget)) {
                setShowGenSkillsOptions(false)
            }
        }, 2000)
    }
    const handleGenSearchChange = e => {
        setSearchGQuery(e.target.value)
    }
    const filteredGenSkillOptions = domainGenSkills?.filter(
        skill =>
            skill.label &&
            skill.value &&
            skill.label.trim() !== '' &&
            skill.value.trim() !== '' &&
            (searchGQuery
                ? skill.label.toLowerCase().includes(searchGQuery.toLowerCase())
                : true)
    )
    const excludedGenSkills = selectGSkills
    const visibleAllGenSkillsOptions = filteredGenSkillOptions?.filter(
        skill => !excludedGenSkills.includes(skill.value)
    )
    const visibleSuggestedGenSkillsOptions = genSuggestedSkillOptions?.filter(
        skill => !excludedGenSkills.includes(skill.value)
    )
    const visibleAllSkillsOptions = [
        ...(visibleAllProfSkillsOptions || []),
        ...(visibleAllGenSkillsOptions || [])
    ]

    // Call debounced function on inputValue change
    useEffect(() => {
        updateOptions(inputValue)
    }, [inputValue])

    const customSkillsStyles = {
        menu: provided => ({
            ...provided,
            padding: 10
        }),
        menuList: provided => ({
            ...provided,
            display: 'grid',
            gridTemplateColumns: window.innerWidth < 600 ? '1fr ' : 'repeat(4, 1fr)', // Two-column layout
            gap: 10
        }),
        option: (provided, state) => ({
            ...provided,
            cursor: 'pointer',
            backgroundColor: state.isSelected ? '#e0f7fa' : '#fff',
            border: state.isFocused ? '1px solid #00796b' : '1px solid #ccc',
            borderRadius: '10px',
            padding: '5px',
            textAlign: 'center',
            boxShadow: state.isFocused ? '0 2px 5px rgba(0, 0, 0, 0.2)' : 'none'
        }),
        multiValue: provided => ({
            ...provided,
            backgroundColor: '#e0e0e0',
            borderRadius: '15px',
            padding: '0 2px',
            margin: '2px'
        }),
        multiValueLabel: provided => ({
            ...provided,
            color: '#000'
        }),
        multiValueRemove: provided => ({
            ...provided,
            color: '#ff5252',
            cursor: 'pointer'
        })
    }

    const handleProSkillSelect = selectedOptions => {
        console.log('selectedOption: ', selectedOptions)

        // Handle deselection (when all options are removed)
        if (!selectedOptions) {
            setSelectPSkills([])
            return
        }

        // Handle both single selection from suggested skills and multi-select from dropdown
        if (Array.isArray(selectedOptions)) {
            // Handle multi-select from dropdown
            const skills = selectedOptions.map(option => option.value)
            setSelectPSkills(skills)
        } else {
            // Handle single selection from suggested skills
            const newSkill = selectedOptions.value

            setSelectPSkills(prevSkills => {
                // If skill already exists, don't add it again
                if (prevSkills.includes(newSkill)) {
                    return prevSkills
                }
                return [...prevSkills, newSkill]
            })
        }
    }

    useEffect(() => {
        setSelectPSkills(selectPSkills)
    }, [])

    console.log('selectPSkills: ', selectPSkills)

    // skills selction section end

    ////////////////////////////////////////////////////////////////////////////////////
    const [uploadedImage, setUploadedImage] = useState('')
    const [fileUploaded, setFileUploaded] = useState(false)

    console.log('image url: ', uploadedImage)

    const handleImageChange = async e => {
        setBtnDisable(true)
        console.log('handleImageChange fuc triggerd !!!!!')

        const file = e.target.files[0]

        if (file) {
            // Check if the file type is an image
            const validImageTypes = [
                'image/jpeg',
                'image/png',
                'image/gif',
                'image/webp'
            ]
            if (!validImageTypes.includes(file.type)) {
                alert('Please upload a valid image file (JPEG, PNG, GIF, or WEBP)')
                // Reset the input value to clear the invalid file
                e.target.value = ''

                return
            }
        }

        console.log('Selected file:', file)
        if (file) {
            setPreviewImage(URL.createObjectURL(file))
            setFileName(file.name)
            try {
                const imageUrl = await uploadRefImage(file, 'banner') // Wait for the image URL
                console.log('uploaded image url:', imageUrl)

                console.log('Call handleSetImage with the image URL')
                await handleSetImage(imageUrl) // Call handleSetImage with the image URL
            } catch (error) {
                console.error('Error handling image change:', error)
            }
        }
        setBtnDisable(false)
    }

    const uploadRefImage = async (filePath, type) => {
        setBtnDisable(true)
        setFileUploaded(true)
        const formData = new FormData()
        formData.append('inputFile', filePath)
        try {
            const res = await axios.post(
                'https://api.allpos.in/applications/upload/scopehai',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            if (type == 'banner') {
                setUploadedImage(res.data.data)
                setFileUploaded(false)
            }
            setBtnDisable(false)
            return res.data.data // Return the uploaded image URL
        } catch (err) {
            setFileUploaded(false)
            setBtnDisable(false)
            throw err
        }
    }

    const handleSetImage = async imageUrl => {
        console.log('handel set image fuc triggerd !!!!!')
        console.log('image URL: ', imageUrl)

        const imageUrlObject = {
            image: imageUrl
        }

        // await postUserImage(ID, imageUrlObject, candidateAuth);

        setUserInfo(prevUserInfo => ({
            ...prevUserInfo,
            Image: imageUrl // Use the provided image URL
        }))

        setImageSet(true)
        setPreviewImage(null)

        fileInputRef.current.value = ''
    }
    ////////////////////////////////////////////////////////////////////////////////////

    console.log('isUpdate btn : ', isUpdate)

    const handleCompanyLogoUpload = async (filePath) => {
        try {
            const uploadedUrl = await uploadRefImage(filePath, 'companyLogo')
            setCompanyLogoArr(prev => [...prev, { 'title': '', 'image': uploadedUrl }]) // Append to previous state
        } catch (error) {
            console.error('Error uploading company logo:', error)
        }
    }

    const handleRemoveCompanyLogo = (index) => {
        setCompanyLogoArr(prev => prev.filter((_, i) => i !== index))
    }

    useEffect(() => {
        console.log('BEFORE  Company Logo Array:', companyLogoArr);
        if (companyLogoArr.length > 0) {
            console.log('AFTER Company Logo Array:', companyLogoArr);
        }
    }, [companyLogoArr])

    return (
        <div className="section mb-2 mt-5 full position-relative">
            {/* css horizontal loder start */}
            {dotLoder && (
                <>
                    <div class="horizontal-loder-bg"></div>
                    <div class="horizontal-loader"></div>
                </>
            )}
            {/* css horizontal loder end */}

            <div className="container py-3">
                <div className="d-flex align-items-center">
                    <Link to="/emp-placement-drives" type="submit" className="my-2 pe-2">
                        <FaArrowLeft style={{ width: '23px', height: '23px' }} />
                    </Link>
                    <h1 className="text-primary mb-0">Add new placement drive</h1>
                </div>
                <div className="my-2 ">
                    <label style={{ paddingLeft: '2px', color: 'black' }}>
                        Placement Drive Banner{' '}
                        <span style={{ color: '#737373', fontSize: '12px' }}>Optional</span>
                    </label>
                    <div className="mt-1 d-flex">
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                                height: '6rem',
                                width: '6rem',
                                backgroundColor: '#F5F5F5',
                                borderRadius: '4px'
                            }}
                        >
                            <label htmlFor="fileUpload" class="cursor-pointer">
                                {previewImage || userInfo.Image ? (
                                    <img
                                        style={{
                                            color: 'grey',
                                            height: '6rem',
                                            width: '6rem',
                                            backgroundColor: '#F5F5F5',
                                            borderRadius: '4px'
                                        }}
                                        src={previewImage || userInfo.Image}
                                        alt="avatar"
                                        className="image"
                                    />
                                ) : (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '6rem',
                                            width: '6rem',
                                            backgroundColor: '#F5F5F5',
                                            borderRadius: '4px',
                                            color: 'grey'
                                        }}
                                    >
                                        <FolderPlus size={50} />
                                    </div>
                                )}
                            </label>
                        </div>

                        <Row>
                            <div style={{ display: 'inline-block', position: 'relative' }}>
                                <label
                                    htmlFor="fileUpload"
                                    className="ms-1"
                                    style={{
                                        padding: '10px 70px 10px 10px',
                                        border: '1px solid #E5E5E5',
                                        borderRadius: '8px',
                                        fontWeight: '500',
                                        display: 'inline-block',
                                        backgroundColor: 'white',
                                        color: 'black',
                                        fontSize: '16px',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        textAlign: 'center'
                                    }}
                                >
                                    Upload File{' '}
                                    <span style={{ color: 'black', fontWeight: '300' }}>
                                        {fileName}
                                    </span>
                                </label>
                                <input
                                    id="fileUpload"
                                    type="file"
                                    accept="image/*"
                                    custom
                                    label="Choose Image"
                                    onChange={handleImageChange}
                                    style={{
                                        width: '15rem',
                                        left: '22px',
                                        opacity: 0,
                                        position: 'absolute',
                                        zIndex: -1
                                    }}
                                />
                            </div>
                            <div>
                                {fileUploaded ? (
                                    <span className="text-nowrap" style={{ marginLeft: '10px' }}>
                                        uploading...
                                    </span>
                                ) : (
                                    ''
                                )}
                            </div>
                        </Row>
                    </div>
                </div>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            onChange={handleInputTitle}
                            value={placementTitle}
                            placeholder="Enter Placement Drive Title"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid Title.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Sub-Title</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder="Enter Sub-Title"
                            onChange={e => setSubTitle(e.target.value)}
                            value={subTitle}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid Sub-Title.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Avg. Package</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder="Enter Avg. Package"
                            onChange={e => setAvragePackage(e.target.value)}
                            value={avragePackage}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid Package.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="validationCustom01">
                        <Form.Label>Openings</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={numValueProfiles}
                            onChange={handleInputProfiles}
                            placeholder="Enter number of Openings"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid number of Openings.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <div className="d-md-flex gap-2 mb-2">
                        <Form.Group className="my-0 d-flex">
                            {/* <Form.Label>Start Date(YYYY/MM/DD)</Form.Label> */}
                            <InputGroup.Text id="inputGroup-sizing-default">
                                <ion-icon
                                    name="calendar-outline"
                                    style={{ color: '#45a994' }}
                                ></ion-icon>
                            </InputGroup.Text>
                            <InputGroup>
                                <DatePicker
                                    style={{ height: '100%' }}
                                    showIcon
                                    selected={startDate}
                                    onChange={date => setStartDate(date)}
                                    icon="fa fa-calendar"
                                    dateFormat="dd/MM/yyyy"
                                />
                            </InputGroup>
                        </Form.Group>
                        <div className="d-flex align-items-center">
                            <h4 className="m-0">to</h4>
                        </div>
                        <Form.Group className="my-0">
                            {/* <Form.Label>End Date(dd/mm/yyyy)</Form.Label> */}
                            <InputGroup>
                                <DatePicker
                                    showIcon
                                    selected={endDate}
                                    onChange={date => setEndDate(date)}
                                    minDate={startDate}
                                    icon="fa fa-calendar"
                                    dateFormat="dd/MM/yyyy"
                                />
                            </InputGroup>
                        </Form.Group>
                    </div>

                    <Form.Group className="my-3">
                        <Form.Label>Qualification</Form.Label>
                        <Form.Select
                            required
                            value={selectEduQualification}
                            aria-label="Default select example"
                            onChange={e => setSelectEduQualification(e.target.value)}
                        >
                            <option selected disabled value="">
                                Select your educational qualification
                            </option>
                            <option value="12th Pass">12th Pass</option>
                            <option value="Diploma">Diploma</option>
                            <option value="ITI">ITI</option>
                            <option value="Graduate">Graduate</option>
                            <option value="Post graduate">Post graduate</option>
                            <option value="PHD">PHD</option>
                        </Form.Select>
                    </Form.Group>

                    {/* <Form.Group className='my-3'>
                        <Form.Label>Eligibility</Form.Label>
                        <Select
                            isMulti
                            options={Array.from(new Set(domainData?.map(item => item.Domain))) // Extract unique domains
                                .map(domain => ({ value: domain, label: domain }))} // Format for react-select
                            isSearchable
                            placeholder="Select eligibility"
                            onChange={(selectedOptions) => setEligibility(selectedOptions.map(option => option.value))}
                        />
                    </Form.Group> */}

                    <div className="d-flex justify-content-between gap-4">
                        <Form.Group className="my-3 w-50">
                            <Form.Label>Select Domain</Form.Label>
                            <Select
                                options={Array.from(
                                    new Set(domainData?.map(item => item.Domain))
                                ).map(domain => ({ value: domain, label: domain }))}
                                isSearchable
                                value={domain ? { value: domain, label: domain } : null}
                                placeholder="Select a domain"
                                onChange={selectedOption => setDomain(selectedOption.value)}
                            />
                        </Form.Group>

                        <Form.Group className="my-3 w-50">
                            <Form.Label>Number of Companies</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                onChange={e => setNoOfCompany(e.target.value)}
                                value={noOfCompany}
                                placeholder="Enter number of Companies"
                            />
                            <Form.Control.Feedback type="invalid">
                                Please provide a valid Title.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </div>

                    {/* highlights */}
                    <lable>Highlights</lable>
                    <div className="my-2 p-2 rounded">
                        {highlights?.map((item, index) => (
                            <div key={item.id} className="mb-3 position-relative">
                                <div
                                    className="position-absolute"
                                    onClick={() => removeHighlights(item.id)}
                                    style={{ right: '0px', color: 'red' }}
                                >
                                    <ion-icon name="trash-outline"></ion-icon>
                                </div>
                                <Form.Group>
                                    <Form.Label className="text-black">Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={item.title}
                                        onChange={e =>
                                            handleHighlightsInputChange(
                                                item.id,
                                                'title',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Form.Group>
                            </div>
                        ))}
                        <Button
                            className="btn-sm"
                            variant="primary"
                            onClick={addHighlights}
                        >
                            <ion-icon name="add-outline"></ion-icon> Add More
                        </Button>
                        <hr></hr>
                    </div>

                    {/* process */}
                    <lable>Process</lable>
                    <div className="p-2 rounded">
                        {process.map((item, index) => (
                            <div key={item.id} className="mb-3 position-relative">
                                <div
                                    className="position-absolute"
                                    onClick={() => removeProcess(item.id)}
                                    style={{ right: '0px', color: 'red' }}
                                >
                                    <ion-icon name="trash-outline"></ion-icon>
                                </div>
                                <Form.Group>
                                    <Form.Label className="text-black">Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={item.title}
                                        onChange={e =>
                                            handleProcessInputChange(item.id, 'title', e.target.value)
                                        }
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label className="text-black">Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        value={item.description}
                                        onChange={e =>
                                            handleProcessInputChange(
                                                item.id,
                                                'description',
                                                e.target.value
                                            )
                                        }
                                    />
                                </Form.Group>
                            </div>
                        ))}
                        <Button className="btn-sm" variant="primary" onClick={addProcess}>
                            <ion-icon name="add-outline"></ion-icon> Add More
                        </Button>
                        <hr></hr>
                    </div>

                    {/* FAQ's section */}
                    <lable>FAQ's</lable>
                    <div className="p-2 rounded">
                        {faq.map((item, index) => (
                            <div key={item.id} className="mb-3 position-relative">
                                <div
                                    className="position-absolute"
                                    onClick={() => removeFAQ(item.id)}
                                    style={{ right: '0px', color: 'red' }}
                                >
                                    <ion-icon name="trash-outline"></ion-icon>
                                </div>
                                <Form.Group>
                                    <Form.Label className="text-black">Question</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={item.question}
                                        onChange={e =>
                                            handleFAQInputChange(item.id, 'question', e.target.value)
                                        }
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label className="text-black">answer</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        value={item.answer}
                                        onChange={e =>
                                            handleFAQInputChange(item.id, 'answer', e.target.value)
                                        }
                                    />
                                </Form.Group>
                            </div>
                        ))}
                        <Button className="btn-sm" variant="primary" onClick={addFAQ}>
                            <ion-icon name="add-outline"></ion-icon> Add More
                        </Button>
                        <hr></hr>
                    </div>

                    {/* multi select skills section */}
                    <div
                        className="d-flex flex-column justify-content-center align-items-start p-1"
                        style={{
                            marginTop: '2rem',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '14px'
                        }}
                    >
                        <lable
                            className="mb-0 w-100 d-flex justify-content-between"
                            style={{ fontWeight: '500', color: 'black' }}
                        >
                            <span>Select skills</span>
                            <span class="text-secondary">10 of 10</span>
                        </lable>
                        <Form.Group className="w-100 boxed my-2" ref={searchProfSkillsRef}>
                            <InputGroup className="boxed position-relative flex-nowrap">
                                <InputGroup.Text className="border-none bg-white">
                                    <span className="fa fa-search"></span>
                                </InputGroup.Text>
                                <Select
                                    isMulti
                                    id="profSkillsSearch"
                                    options={visibleAllSkillsOptions}
                                    value={selectPSkills.map(skill => ({
                                        value: skill,
                                        label: skill
                                    }))} // Map skills to the format expected by Select
                                    styles={customSkillsStyles}
                                    placeholder="Search or select from the list below"
                                    className="basic-multi-select border-none"
                                    classNamePrefix="select"
                                    onChange={handleProSkillSelect} // Handle select and deselect
                                    onFocus={() => console.log('Focus event')} // Optional: handle focus
                                    onBlur={() => console.log('Blur event')} // Optional: handle blur
                                    components={{
                                        DropdownIndicator: () => null,
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </InputGroup>
                        </Form.Group>
                    </div>

                    <Row>
                        <div className="d-flex">
                            <div className="">
                                <Form.Group className="my-3">
                                    {/* <Form.Label>Location</Form.Label> */}
                                    <div className="d-flex" style={{ height: '37px' }}>
                                        <InputGroup.Text
                                            id="inputGroup-sizing-default"
                                            style={{ height: '37px' }}
                                        >
                                            <ion-icon
                                                name="location-outline"
                                                style={{ color: '#45a994' }}
                                            ></ion-icon>
                                            {/* <IoLocationOutline style={{color: '#45a994'}}/> */}
                                        </InputGroup.Text>
                                        <Form.Select
                                            required
                                            aria-label="Default select example"
                                            onChange={e => setSelectLocation(e.target.value)}
                                            value={selectLocation}
                                        >
                                            <option selected disabled value="">
                                                Select location
                                            </option>
                                            <option value="Mumbai">Mumbai</option>
                                            <option value="Navi Mumbai">Navi Mumbai</option>
                                            <option value="Panvel">Panvel</option>
                                            <option value="Pune">Pune</option>
                                            <option value="Satara">Satara</option>
                                            <option value="Nashik">Nashik</option>
                                        </Form.Select>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>
                    </Row>
                    <hr></hr>
                    {/* Company logo upload */}
                    <div className="my-4">
                        <lable>Company Data</lable>
                        <div class="ps-2 mt-3">
                            <Form.Group>
                                {/* <div>
                                    <Form.Label className="text-black">Image Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value=""
                                    />
                                </div> */}
                                <div class="mt-2">
                                    <Form.Label className="text-black">Logo</Form.Label>
                                    <div class="d-flex gap-3">
                                        {companyLogoArr.length > 0 &&
                                            <>
                                                {companyLogoArr?.map((v, k) => {
                                                    console.log(v)
                                                    return (
                                                        <div style={{ position: 'relative' }}>
                                                            <div class="d-flex justify-content-center align-items-center cursor-pointer" style={{ borderRadius: '100px', height: '25px', width: '25px', background: '#ffffff8c', position: 'absolute', top: 5, right: 5 }} onClick={() => { handleRemoveCompanyLogo(k) }}>
                                                                <ion-icon name="trash-outline" class="text-danger"></ion-icon>
                                                            </div>
                                                            <img src={v.image} width={'120px'} height={'120px'} style={{ border: '1px solid lightgray', objectFit: 'cover' }} />
                                                        </div>
                                                    )
                                                })}
                                            </>
                                        }
                                        <Form.Label className="text-black d-flex justify-content-center align-items-center text-secondary  fs-6" htmlFor='uploadCompanyLogo' style={{ border: '1px solid lightgray', cursor: 'pointer', height: '120px', width: '120px', borderStyle: 'dashed', borderRadius: '4px' }}>
                                            Click to upload
                                        </Form.Label>
                                        <Form.Control
                                            id='uploadCompanyLogo'
                                            type="file"
                                            className="d-none"
                                            accept=".jpg,.jpeg,.png"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
                                                    const maxSize = 2 * 1024 * 1024; // 2MB

                                                    if (!validTypes.includes(file.type)) {
                                                        alert('Only JPG, JPEG, and PNG files are allowed.');
                                                        return;
                                                    }

                                                    if (file.size > maxSize) {
                                                        alert('File size should not exceed 2 MB.');
                                                        return;
                                                    }

                                                    handleCompanyLogoUpload(file);
                                                }
                                            }}
                                        // onChange={(e)  => {handleCompanyLogoUpload(e.target.files[0])}}
                                        />
                                    </div>
                                </div>
                            </Form.Group>
                        </div>
                    </div>
                    <Row>
                        {updatebtn ? (
                            <div className="d-flex gap-2">
                                <Button
                                    type="button"
                                    variant="outline-primary"
                                    onClick={() => navigate('/emp-placement-drives')}
                                >
                                    Cancel
                                </Button>
                                {(role === 'Counsellor' || role === 'Admin') && (
                                    <>
                                        <Button
                                            className="btn-block"
                                            type="submit"
                                            variant="primary"
                                            onClick={() => setIsupdate(true)}
                                            disabled={btnDisable}
                                        >
                                            Update placement drive
                                        </Button>
                                    </>
                                )}

                                {role === 'Employer' && (
                                    <>
                                        <Button
                                            className="btn-block"
                                            type="submit"
                                            variant="primary"
                                            onClick={() => setIsupdate(true)}
                                            disabled={btnDisable}
                                        >
                                            Update placement drive
                                        </Button>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="d-flex gap-2">
                                <Button
                                    type="button"
                                    variant="outline-primary"
                                    onClick={() => window.history.back()}
                                >
                                    Cancel
                                </Button>
                                <Button className="btn-block" type="submit" variant="primary" disabled={btnDisable}>
                                    Create placement drive
                                </Button>
                            </div>
                        )}
                    </Row>
                </Form>

                {/* olf PD from */}
                <Form
                    className="d-none"
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                >
                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            onChange={handleInputTitle}
                            value={placementTitle}
                            placeholder="Enter Placement Drive Title"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid Title.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Sub-Title</Form.Label>
                        <Form.Control required type="text" placeholder="Enter Sub-Title" />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid Sub-Title.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Avg. Package</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder="Enter Avg. Package"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid Package.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="validationCustom01">
                        <Form.Label>Openings</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={numValueProfiles}
                            onChange={handleInputProfiles}
                            placeholder="Enter number of Openings"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid number of Openings.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <div className="d-md-flex gap-2 mb-2">
                        <div>
                            <h4 className="m-0">Select Date</h4>
                        </div>
                        <Form.Group className="my-0 d-flex">
                            {/* <Form.Label>Start Date(YYYY/MM/DD)</Form.Label> */}
                            <InputGroup.Text id="inputGroup-sizing-default">
                                <ion-icon
                                    name="calendar-outline"
                                    style={{ color: '#45a994' }}
                                ></ion-icon>
                            </InputGroup.Text>
                            <InputGroup>
                                <DatePicker
                                    style={{ height: '100%' }}
                                    showIcon
                                    selected={startDate}
                                    onChange={date => setStartDate(date)}
                                    icon="fa fa-calendar"
                                    dateFormat="dd/MM/yyyy"
                                />
                            </InputGroup>
                        </Form.Group>
                        <div className="d-flex align-items-center">
                            <h4 className="m-0">to</h4>
                        </div>
                        <Form.Group className="my-0">
                            {/* <Form.Label>End Date(dd/mm/yyyy)</Form.Label> */}
                            <InputGroup>
                                <DatePicker
                                    showIcon
                                    selected={endDate}
                                    onChange={date => setEndDate(date)}
                                    minDate={startDate}
                                    icon="fa fa-calendar"
                                    dateFormat="dd/MM/yyyy"
                                />
                            </InputGroup>
                        </Form.Group>
                    </div>

                    <Form.Group className="my-3">
                        <Form.Label>Qualification</Form.Label>
                        <Form.Select
                            required
                            aria-label="Default select example"
                            onChange={e => setSelectEduQualification(e.target.value)}
                        >
                            <option selected disabled value="">
                                Select your educational qualification
                            </option>
                            <option value="12th Pass">12th Pass</option>
                            <option value="Diploma">Diploma</option>
                            <option value="ITI">ITI</option>
                            <option value="Graduate">Graduate</option>
                            <option value="Post graduate">Post graduate</option>
                            <option value="PHD">PHD</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="my-3">
                        <Form.Label>Select Domain</Form.Label>
                        <Select
                            options={Array.from(new Set(domainData?.map(item => item.Domain))) // Extract unique domains
                                .map(domain => ({ value: domain, label: domain }))} // Format for react-select
                            isSearchable
                            placeholder="Select a domain"
                            onChange={selectedOption => setDomain(selectedOption.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        {/* <Form.Label>Criteria</Form.Label> */}
                        <Form.Control
                            required
                            as="textarea"
                            placeholder="Description"
                            onChange={handleInputCriteria}
                            value={placementCriteria}
                            style={{ height: '100px' }}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid Criteria.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="my-3">
                        {/* <Form.Label>Location</Form.Label> */}
                        <div className="w-25 d-flex" style={{ height: '37px' }}>
                            <InputGroup.Text
                                id="inputGroup-sizing-default"
                                style={{ height: '37px' }}
                            >
                                <ion-icon
                                    name="location-outline"
                                    style={{ color: '#45a994' }}
                                ></ion-icon>
                                {/* <IoLocationOutline style={{color: '#45a994'}}/> */}
                            </InputGroup.Text>
                            <Form.Select
                                required
                                aria-label="Default select example"
                                onChange={e => setSelectLocation(e.target.value)}
                                value={selectLocation}
                            >
                                <option selected disabled value="">
                                    Select location
                                </option>
                                <option value="Mumbai">Mumbai</option>
                                <option value="Navi Mumbai">Navi Mumbai</option>
                                <option value="Panvel">Panvel</option>
                                <option value="Pune">Pune</option>
                            </Form.Select>
                        </div>
                    </Form.Group>

                    <div className="d-flex gap-2">
                        <Button type="submit" variant="primary">
                            Create placement drive
                        </Button>
                        <Button
                            type="button"
                            variant="outline-primary"
                            onClick={() => window.history.back()}
                        >
                            Cancel
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

const mapStateToProps = ({ auth }) => {
    const { userData, role, fullName, ID, authToken } = auth

    return {
        userData,
        role,
        fullName,
        ID,
        authToken
    }
}

const mapDispatchToProps = {
    setToken
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewPlacementDriveForm)

// export default NewPlacementDriveForm
// export default NewPlacementDriveForm
// export default NewPlacementDriveForm
